import {
  SET_SELECTED_CARD,
  SET_CLEAR_SELECTION,
  SET_HAS_MORE,
  SET_SEARCH,
} from './reducer';

export const setSelectedCard = (entity) => (dispatch) => {
  const payload = {
    entity,
  };
  dispatch({
    type: SET_SELECTED_CARD,
    payload,
  });
};

export const setClearSelection = () => (dispatch) => {
  dispatch({ type: SET_CLEAR_SELECTION });
};

export const setHasMore = (hasMore) => (dispatch) => {
  const payload = {
    hasMore,
  };

  dispatch({
    type: SET_HAS_MORE,
    payload,
  });
};

export const setSearch = (search) => (dispatch) => {
  const payload = {
    search,
  };

  dispatch({
    type: SET_SEARCH,
    payload,
  });
};
